(function () {
function isJourneyMobileSlider() {
    return window.innerWidth <= 768;
}

function getJourneyBreakpoint() {
    return isJourneyMobileSlider() ? 'mobile' : 'desktop';
}

function getJourneySplideOptions() {
    if (isJourneyMobileSlider()) {
        return {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            fixedWidth: false,
            fixedHeight: false,
            autoHeight: true,
            gap: 0,
            padding: {
                left: 0,
                right: 0,
            },
            pagination: false,
            arrows: false,
            drag: true,
            snap: true,
            focus: 0,
            trimSpace: true,
        };
    }

    return {
        type: 'slide',
        perPage: 2,
        perMove: 2,
        gap: '10px',
        autoHeight: true,
        pagination: false,
        arrows: false,
        drag: true,
        snap: true,
        focus: 0,
        trimSpace: false,
        padding: {
            left: 0,
            right: 0,
        },
    };
}

function getJourneyDotCount(slideCount) {
    if (isJourneyMobileSlider()) {
        return slideCount;
    }

    return Math.max(1, Math.ceil(slideCount / 2));
}

function getJourneyDotIndex(slideIndex) {
    if (isJourneyMobileSlider()) {
        return slideIndex;
    }

    return Math.floor(slideIndex / 2);
}

function getJourneySlideIndexFromDot(dotIndex) {
    if (isJourneyMobileSlider()) {
        return dotIndex;
    }

    return dotIndex * 2;
}

function removeJourneySplidePagination(root) {
    root.querySelectorAll('.splide__pagination').forEach((pagination) => {
        pagination.remove();
    });
}

function initHomeJourneySlider(root) {
    if (typeof Splide === 'undefined') {
        return;
    }

    const section = root.closest('.home-journey');
    const prevBtn = section?.querySelector('[data-journey-prev]');
    const nextBtn = section?.querySelector('[data-journey-next]');
    const dotsRoot = section?.querySelector('[data-journey-dots]');
    const slideCount = Number(dotsRoot?.getAttribute('data-journey-slide-count') || root.querySelectorAll('.splide__slide').length);
    let splide = null;
    let breakpoint = getJourneyBreakpoint();
    let resizeTimer = null;

    const renderDots = () => {
        if (!dotsRoot) {
            return;
        }

        const dotCount = getJourneyDotCount(slideCount);
        dotsRoot.innerHTML = '';

        for (let index = 0; index < dotCount; index += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = `home-journey__dot${index === 0 ? ' is-active' : ''}`;
            dot.setAttribute('data-journey-dot', String(index));
            dot.setAttribute('aria-label', `Rodyti kortelę ${index + 1}`);
            dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
            dotsRoot.appendChild(dot);
        }
    };

    const getDots = () => section?.querySelectorAll('[data-journey-dot]') ?? [];

    const updateDots = (index) => {
        const activeDot = getJourneyDotIndex(index);

        getDots().forEach((dot) => {
            const dotIndex = Number(dot.getAttribute('data-journey-dot'));
            const isActive = dotIndex === activeDot;

            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
    };

    const updateNavButtons = () => {
        if (!splide || !prevBtn || !nextBtn) {
            prevBtn?.removeAttribute('disabled');
            nextBtn?.removeAttribute('disabled');
            return;
        }

        prevBtn.disabled = splide.index === 0;
        nextBtn.disabled = splide.index >= splide.Components.Controller.getEnd();
    };

    const bindDotControls = () => {
        if (!splide) {
            return;
        }

        getDots().forEach((dot) => {
            dot.addEventListener('click', () => {
                const dotIndex = Number(dot.getAttribute('data-journey-dot'));
                splide.go(getJourneySlideIndexFromDot(dotIndex));
            });
        });
    };

    const bindNavControls = () => {
        if (!prevBtn || !nextBtn || prevBtn.dataset.journeyBound === 'true') {
            return;
        }

        prevBtn.addEventListener('click', () => {
            splide?.go('<');
        });
        nextBtn.addEventListener('click', () => {
            splide?.go('>');
        });

        prevBtn.dataset.journeyBound = 'true';
        nextBtn.dataset.journeyBound = 'true';
    };

    const mountSlider = ({ preserveIndex = false } = {}) => {
        const targetIndex = preserveIndex && splide ? splide.index : 0;

        if (splide) {
            splide.destroy(true);
            splide = null;
        }

        renderDots();
        removeJourneySplidePagination(root);

        splide = new Splide(root, getJourneySplideOptions());

        splide.on('mounted', () => {
            removeJourneySplidePagination(root);
            bindDotControls();

            if (preserveIndex && targetIndex > 0) {
                splide.go(Math.min(targetIndex, splide.Components.Controller.getEnd()));
            }

            updateDots(splide.index);
            updateNavButtons();
        });

        splide.on('move', (index) => {
            updateDots(index);
            updateNavButtons();
        });

        splide.on('resized', updateNavButtons);

        splide.mount();
    };

    bindNavControls();
    mountSlider();

    const handleResize = () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
            const nextBreakpoint = getJourneyBreakpoint();

            if (nextBreakpoint !== breakpoint) {
                breakpoint = nextBreakpoint;
                mountSlider({ preserveIndex: true });
                return;
            }

            if (!splide) {
                return;
            }

            splide.options = getJourneySplideOptions();
            splide.refresh();
            updateDots(splide.index);
            updateNavButtons();
        }, 200);
    };

    window.addEventListener('resize', handleResize);
}

document.querySelectorAll('[data-home-journey-slider]').forEach(initHomeJourneySlider);

})();
